export default __webpack_public_path__ + "93c2f932e0c6699f621c6d83fb993cc9.obj";